// extracted by mini-css-extract-plugin
export default {"live-chat":"LiveChat_live-chat__ID7BZ","icon":"LiveChat_icon__jhiuV"};